export const formatDollarAmount = (dollarAmount) => {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });

    return formatter.format(dollarAmount);
};



// WEBPACK FOOTER //
// ./src/utils/data.js